import type {
  AxiosError,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from 'axios'
import axios from 'axios'

import { TENANT_DATA_COOKIE, TOKEN_NAME_COOKIE } from './utils'

import { env } from '@/env'
import type { Domain } from '@/types/domain'

const isServer = typeof window === 'undefined'

const http = axios.create({
  baseURL: isServer ? env.NEXT_API_URI : env.NEXT_PUBLIC_API_URI,
  //withCredentials: isServer,
  headers: {
    'Content-Type': 'application/json',
  },
  validateStatus: function (status: number) {
    return status >= 200 && status < 300
  },
})

http.interceptors.request.use(
  async (config: InternalAxiosRequestConfig) => {
    let accessToken: string | undefined
    let tenantId: string | undefined

    if (isServer) {
      const { cookies } = await import('next/headers')
      const cookiesInstance = await cookies()

      if (cookiesInstance.has(TOKEN_NAME_COOKIE)) {
        accessToken = cookiesInstance.get(TOKEN_NAME_COOKIE)?.value
      }

      if (cookiesInstance.has(TENANT_DATA_COOKIE)) {
        const storagedTenant = cookiesInstance.get(TENANT_DATA_COOKIE)
          ?.value as string
        const tenand = JSON.parse(storagedTenant) as Domain
        tenantId = tenand.tenant_id.toString()
      }
    }

    if (!isServer) {
      const { parseCookies } = await import('nookies')
      const cookiesInstance = parseCookies()

      if (cookiesInstance[TOKEN_NAME_COOKIE]) {
        accessToken = cookiesInstance[TOKEN_NAME_COOKIE]
      }

      if (cookiesInstance[TENANT_DATA_COOKIE]) {
        const storagedTenant = cookiesInstance[TENANT_DATA_COOKIE] as string
        const tenand = JSON.parse(storagedTenant) as Domain
        tenantId = tenand.tenant_id.toString()
      }
    }

    if (tenantId) {
      config.headers['X-Tenant'] = tenantId
    }

    if (accessToken) {
      config.headers['Authorization'] = `Bearer ${accessToken}`
    }

    return config
  },
  (error: AxiosError) => {
    return Promise.reject(error.response)
  },
)

http.interceptors.response.use(
  (response: AxiosResponse) => {
    if (response.status === 204) {
      response.data = {}
    }
    return response
  },
  (error: AxiosError) => {
    const statusCode = error.response?.status

    if (typeof window !== 'undefined' && statusCode === 401) {
      window.location.href = '/auth/sign-out'
    }

    return Promise.reject(error.response)
  },
)

export { http }
